/**
 * This file provides utility functions to debug environment variables in production
 */

/**
 * Log all environment variables
 */
export const logEnvironmentVariables = () => {
  console.log('===== Environment Variables Debug =====');
  console.log('VITE_API_URL:', import.meta.env.VITE_API_URL);
  console.log('VITE_API_URL type:', typeof import.meta.env.VITE_API_URL);
  console.log('Production mode:', import.meta.env.PROD);
  console.log('Development mode:', import.meta.env.DEV);
  
  // Log all variables
  console.log('All environment variables:');
  for (const key in import.meta.env) {
    try {
      console.log(`- ${key}:`, import.meta.env[key]);
    } catch (e) {
      console.log(`- ${key}: [Error accessing value]`);
    }
  }
  console.log('===== End Environment Variables Debug =====');
};

/**
 * Test API URL construction with different paths
 */
export const testApiUrls = () => {
  const apiBaseUrl = import.meta.env.VITE_API_URL || '/api';
  console.log('===== API URL Construction Tests =====');
  console.log('Base API URL:', apiBaseUrl);
  
  // Add leading slash if missing
  const normalizedBaseUrl = !apiBaseUrl.startsWith('/') && !apiBaseUrl.startsWith('http') 
    ? `/${apiBaseUrl}` 
    : apiBaseUrl;
  
  console.log('Normalized base URL:', normalizedBaseUrl);
  
  // Test with different path formats
  const testPaths = [
    'auth/login',
    '/auth/login',
    'auth/login/',
    '/auth/login/',
  ];
  
  testPaths.forEach(path => {
    const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    const url = `${normalizedBaseUrl}/${normalizedPath}`;
    console.log(`Path "${path}" → "${url}"`);
  });
  
  console.log('===== End API URL Construction Tests =====');
};
